var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "calendar-scroll-month",
      attrs: { "data-month": _vm.month },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isLoading,
              expression: "isLoading",
            },
          ],
          staticClass: "loading-month-wrapper",
        },
        [
          _c("span", { attrs: { role: "presentation", tabindex: "0" } }, [
            _vm._v(" " + _vm._s(_vm.loadingMessage)),
          ]),
          _vm._v(" "),
          _c("loading-dots"),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          ref: "title",
          staticClass: "calendar-scroll-month-title",
          attrs: {
            type: "button",
            "data-component": "calendar-scroll-month-title",
            tabindex: _vm.isVisible ? "0" : "-1",
          },
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.$emit("month-click")
            },
            space: function ($event) {
              $event.preventDefault()
              return _vm.$emit("month-click")
            },
            enter: function ($event) {
              $event.preventDefault()
              return _vm.$emit("month-click")
            },
          },
        },
        [
          _vm._v(
            "\n    " +
              _vm._s(_vm.tc("calendar.months." + _vm.monthIndex)) +
              " " +
              _vm._s(_vm.year) +
              "\n  "
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "calendar-scroll-month-days-wrapper",
          on: {
            click: function ($event) {
              $event.preventDefault()
              $event.stopPropagation()
              return _vm.updateField($event)
            },
            keydown: [
              function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                $event.preventDefault()
                $event.stopPropagation()
                return _vm.updateField($event)
              },
              function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "space", 32, $event.key, [
                    " ",
                    "Spacebar",
                  ])
                ) {
                  return null
                }
                $event.preventDefault()
                $event.stopPropagation()
                return _vm.updateField($event)
              },
            ],
          },
        },
        _vm._l(_vm.daysInMonth, function (day) {
          return _c(
            "button",
            {
              key: day.id,
              staticClass: "calendar-scroll-day",
              class: [
                { error: _vm.errorStatus(day.dayFormatted) },
                { "is-start-date": _vm.isStartDate(day.dayFormatted) },
                { "is-end-date": _vm.isEndDate(day.dayFormatted) },
                { "is-between-date": _vm.isBetweenDate(day.dayFormatted) },
                { "is-selected": _vm.isSelected(day.dayFormatted) },
                {
                  "not-available": _vm.dayStatus(day.dayFormatted) === "Close",
                },
                {
                  "is-past-week":
                    _vm.isPastDate(day.dayFormatted) &&
                    !_vm.dayIsInSameWeek(day.dayFormatted),
                },
                { disabled: _vm.isDisabled(day.dayFormatted) },
              ],
              style: [{ "margin-left": _vm.getMarginLeft(day.dayFormatted) }],
              attrs: {
                id: day.id,
                "data-day": day.dayFormatted,
                "aria-disabled": _vm.isDisabled(day.dayFormatted),
                tabindex: _vm.getDayTabIndex(day.dayFormatted),
                "aria-label": _vm.ariaLabel(day.dayFormatted),
                "aria-pressed": _vm.isSelected(day.dayFormatted),
              },
              on: {
                focus: _vm.bindKeyboardEvents,
                blur: _vm.unbindKeyboardEvents,
              },
            },
            [
              _c("div", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showBackground,
                    expression: "showBackground",
                  },
                ],
                staticClass: "calendar-scroll-day-background no-pointer-events",
                attrs: { "aria-hidden": "true" },
              }),
              _vm._v(" "),
              _c("div", {
                staticClass: "calendar-scroll-day-selected no-pointer-events",
                attrs: { "aria-hidden": "true" },
              }),
              _vm._v(" "),
              _c(
                "span",
                { staticClass: "calendar-scroll-day-label no-pointer-events" },
                [_vm._v("\n        " + _vm._s(day.day) + "\n      ")]
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showPrice(day.dayFormatted),
                      expression: "showPrice(day.dayFormatted)",
                    },
                  ],
                  staticClass: "calendar-scroll-day-price no-pointer-events",
                  attrs: { "aria-hidden": !_vm.showPrice(day.dayFormatted) },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.displayPrice(day.dayFormatted)) +
                      "\n      "
                  ),
                ]
              ),
            ]
          )
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }